<template>
  <b-row class="justify-content-md-center m-0">
    <b-col lg="6" class="py-3">
      <div class="row-topic">
        <div class="row-topic__title">Community Rules and Guidelines</div>
        <div class="row-topic__date">Jul 1, 2023</div>
      </div>
      <div v-for="rule in reverseItems" :key="rule.index" class="text-detail">
        <p class="text-detail__title" v-text="rule.topic"></p>
        <div v-for="content in rule.contents" :key="content.index">
          <p class="text-detail__content" v-text="content.title"></p>
          <ol class="text-detail__list">
            <li
              v-for="item in content.list_items"
              :key="item.index"
              class="text-detail__list-item"
              v-text="item.message"
            ></li>
          </ol>
        </div>
      </div>
    </b-col>
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      rules: [
        {
          lang: 'en',
          topic: 'Rules of Our Community (Translated version)',
          contents: [
            {
              title:
                'In using the community, it is important to establish common agreements and practices. Here are some guidelines for community engagement:',
              list_items: [
                {
                  message:
                    'Polite and appropriate language: Always use polite and appropriate language when communicating with others. Avoid using offensive language, slurs, or behaviors that may create division within the community.'
                },
                {
                  message:
                    'Respect and empathy: Show respect and empathy towards cultural differences, diverse opinions, and strive to build positive relationships with others in the community.'
                },
                {
                  message:
                    'Sharing and supporting: Support and share knowledge, experiences, and helpful information with the community to foster learning and growth for all members.'
                },
                {
                  message:
                    'Sacrifice and Responsibility: Take responsibility for our words and actions within the community. Respect the rights and privacy of others and refrain from engaging in behavior that may cause discomfort or harm to others.'
                },
                {
                  message:
                    'Transparency and trustworthiness: Foster transparency in community operations and the sharing of beneficial information. However, always exercise caution and ensure the trustworthiness of shared information and support regarding copyrighted or confidential content.'
                },
                {
                  message:
                    'Rights and limitations of responsibility: When joining the community, adhere to relevant rules and regulations. Members should exercise their rights appropriately and refrain from misusing them or going beyond the defined boundaries.'
                },
                {
                  message:
                    'Conflict resolution: When conflicts or disagreements arise within the community, strive for resolution and support constructive communication and problem-solving.'
                },
                {
                  message:
                    "Use of personal data and privacy: Use others' personal data appropriately and avoid using it for personal gain or engaging in actions that may harm individuals within the community."
                },
                {
                  message:
                    'Reporting violations: If there are any violations within the community, such as inappropriate posts or actions that breach regulations, report them and communicate with community moderators to address the situation accordingly.'
                },
                {
                  message:
                    'Creating opinions and participation: Learn and actively participate in the community. Express constructive opinions and share ideas that contribute to the development and growth of the community.'
                }
              ]
            },
            {
              title: 'What does NOT belong in the community:',
              list_items: [
                {
                  message:
                    'Harassment and bullying: Any form of harassment, bullying, or targeted mistreatment of individuals based on their race, ethnicity, gender, sexual orientation, religion, or any other personal characteristic is not acceptable in a community.'
                },
                {
                  message:
                    'Hate speech and discrimination: Engaging in hate speech, promoting discrimination, or expressing prejudiced views towards certain individuals or groups is generally not tolerated in a community setting.'
                },
                {
                  message:
                    "Spam and self-promotion: Constantly sharing irrelevant or unsolicited information, advertisements, or self-promotion without contributing to the community's discussions or adding value is spam and is generally discouraged."
                },
                {
                  message:
                    'Trolling and disruptive behavior: Purposefully provoking or inciting arguments, disrupting discussions, or seeking to upset or offend others is not conducive to a positive community environment.'
                },
                {
                  message:
                    'Illegal activities: Engaging in or promoting illegal activities such as sharing copyrighted material, engaging in fraudulent schemes, or advocating for violence is strictly prohibited in most communities.'
                },
                {
                  message:
                    'Personal attacks: Directly attacking or insulting other community members, engaging in name-calling, or making derogatory remarks is detrimental to a healthy and respectful community atmosphere.'
                },
                {
                  message:
                    "Off-topic or irrelevant content: Continuously posting unrelated or off-topic content that does not contribute to the community's purpose or discussions may be considered disruptive."
                }
              ]
            }
          ]
        },
        {
          lang: 'th',
          topic: 'กฎการใช้ Community (Original version)',
          contents: [
            {
              title:
                'เพื่อสร้างความเข้าใจและสร้างชุมชนที่เติบโตและเป็นประโยชน์ต่อทุกคนที่เข้าร่วม มีกฎการใช้ชุมชนดังนี้:',
              list_items: [
                {
                  message:
                    'คำสุภาพและการปฏิบัติที่เหมาะสม: จะใช้ภาษาที่สุภาพและเหมาะสมในการสื่อสารกับผู้อื่นทุกครั้ง ไม่ใช้ภาษาที่ไม่เหมาะสม ลามกอนาจาร หรือข่มเหงสร้างความแตกแยกในชุมชน'
                },
                {
                  message:
                    'ความเคารพและเห็นใจ: ควรให้ความเคารพและเห็นใจต่อความแตกต่างทางวัฒนธรรม ความเห็นที่แตกต่าง และมุ่งเน้นการสร้างสัมพันธภาพที่ดีกับผู้อื่นในชุมชน'
                },
                {
                  message:
                    'การแบ่งปันและการสนับสนุน: สนับสนุนและแบ่งปันความรู้ ประสบการณ์ และข้อมูลที่เป็นประโยชน์กับชุมชน เพื่อช่วยเสริมสร้างการเรียนรู้และการเติบโตของสมาชิกทุกคน'
                },
                {
                  message:
                    'การเสียสละและการรับผิดชอบ: เราต้องรับผิดชอบต่อคำพูดและการกระทำของเราในชุมชน ต้องเคารพสิทธิและความเป็นส่วนตัวของผู้อื่น และไม่ประพฤติตนในลักษณะที่ทำให้เกิดความไม่สบายใจหรือเป็นอันตรายต่อผู้อื่น'
                },
                {
                  message:
                    'ความโปร่งใสและความน่าเชื่อถือ: เราควรสร้างความโปร่งใสในการดำเนินการของชุมชน และการสื่อสารข้อมูลที่เป็นประโยชน์ อย่างไรก็ตาม สมาชิกทุกคนควรตระหนักถึงเรื่องความน่าเชื่อถือในการแชร์ข้อมูล และสนับสนุนเนื้อหาที่มีลิขสิทธิ์'
                },
                {
                  message:
                    'การใช้สิทธิ์และการจำกัดความรับผิดชอบ: เมื่อเข้าร่วมชุมชน ต้องปฏิบัติตามกฎระเบียบและข้อกำหนดที่เกี่ยวข้อง สมาชิกต้องใช้สิทธิ์ที่ได้รับโดยถูกต้องและไม่นำสิทธิ์เหล่านั้นไปใช้อย่างไม่เหมาะสมหรือนอกเหนือจากขอบเขตที่กำหนดไว้'
                },
                {
                  message:
                    'การแก้ไขข้อพิพาท: เมื่อเกิดข้อพิพาทหรือความขัดแย้งในชุมชน ควรแก้ไขให้เรียบร้อย และสนับสนุนให้เกิดการสื่อสารและการแก้ไขด้วยวิธีที่สร้างสรรค์และสร้างความเข้าใจกันได้'
                },
                {
                  message:
                    'การใช้ข้อมูลส่วนตัวและความเป็นส่วนตัว: ควรใช้ข้อมูลส่วนตัวของผู้อื่นอย่างเหมาะสมและไม่นำไปใช้ประโยชน์ส่วนตัวหรือกระทำการที่ส่งผลต่อผู้อื่นในชุมชน'
                },
                {
                  message:
                    'การรายงานการละเมิด: หากมีการละเมิดในชุมชน เช่น การโพสต์ที่ไม่เหมาะสมหรือการกระทำที่ละเมิดกฎระเบียบ ควรรายงานและสื่อสารกับผู้ดูแลชุมชนเพื่อให้มีการแก้ไขสถานการณ์ตามเหตุการณ์ที่เกิดขึ้น'
                },
                {
                  message:
                    'ความคิดเห็นและการมีส่วนร่วม: ควรเรียนรู้และมีส่วนร่วมในชุมชน การแสดงความคิดเห็นและแบ่งปันความคิดเห็นที่สร้างสรรค์จะช่วยสนับสนุนการพัฒนาและเติบโตของชุมชนได้อย่างเต็มที่'
                }
              ]
            },
            {
              title: 'สิ่งที่ไม่เหมาะสมในชุมชน:',
              list_items: [
                {
                  message:
                    'การล่วงละเมิดและการก่อกวน: การล่วงละเมิดหรือก่อกวนหรือการกีดกันโดยเป้าหมายของบุคคลบางรายที่เกี่ยวข้องกับเชื้อชาติ เพศ ศาสนา หรือลักษณะบุคคลอื่น ๆ ไม่เป็นที่ยอมรับในชุมชน'
                },
                {
                  message:
                    'การใช้คำด่าทอและการแบ่งแยก: การใช้คำด่าทอ สนับสนุนการแบ่งแยก หรือแสดงความเห็นที่มีลักษณะคาดเดาเกี่ยวกับบุคคลบางรายหรือกลุ่มบุคคลบางกลุ่มไม่ได้รับการอนุญาตโดยทั่วไปในชุมชน'
                },
                {
                  message:
                    'สแปมและการโฆษณาตนเอง: การแบ่งปันข้อมูลที่ไม่เกี่ยวข้องหรือไม่ได้รับคำขอ โฆษณาหรือการโฆษณาตนเองอย่างต่อเนื่องโดยไม่มีส่วนร่วมในการสนทนาในชุมชนหรือไม่มีคุณค่า สามารถถูกพิจารณาเป็นสแปม'
                },
                {
                  message:
                    'การแกล้งและพฤติกรรมที่รบกวน: การเจตนาให้เกิดการวิวาท การรบกวนการสนทนา หรือความตั้งใจที่จะทำให้ผู้อื่นโกรธหรือถูกทำร้ายไม่เป็นสิ่งที่สร้างสรรค์สำหรับสภาพแวดล้อมชุมชนที่เชิงบวก'
                },
                {
                  message:
                    'กิจกรรมที่ผิดกฎหมาย: การมีส่วนร่วมหรือสนับสนุนกิจกรรมที่ผิดกฎหมาย เช่นการแบ่งปันเนื้อหาที่มีลิขสิทธิ์ การมีส่วนร่วมในโครงการที่เป็นการฉ้อโกง หรือสนับสนุนความรุนแรงถือเป็นเรื่องห้ามอย่างเคร่งครัดในชุมชน'
                },
                {
                  message:
                    'การโจมตีส่วนบุคคล: การโจมตีหรือสบถบุคคลอื่นในชุมชนโดยตรง การใช้ชื่อเรียกในการเรียกชื่อหรือการพูดถ้อยคำที่เกี่ยวข้องในทางลบจะทำให้สภาพแวดล้อมของชุมชนเสื่อมเสียและส่งผลกระทบต่อความเคารพซึ่งกันและกันในชุมชน'
                },
                {
                  message:
                    'เนื้อหานอกเหนือหรือไม่เกี่ยวข้อง: การโพสต์เนื้อหาที่ไม่เกี่ยวข้องหรือไม่มีอยู่ในวัตถุประสงค์ การสนทนาของชุมชนอาจถูกพิจารณาเป็นการรบกวน'
                }
              ]
            }
          ]
        }
      ]
    };
  },
  computed: {
    reverseItems() {
      return this.rules.slice().reverse();
    }
  }
};
</script>

<style lang="scss" scoped>
.row-topic {
  display: flex;
  justify-content: space-between;
  padding-bottom: 35px;
}
.row-topic__title {
  font-weight: bold;
}
.text-detail {
  line-height: 26.44px;
}
.text-detail__title {
  font-weight: 700;
  font-size: 18px;
  line-height: 26.44px;
  padding: 5px 0;
}
.text-detail__content {
  padding: 5px 0;
}
.text-detail__list {
  padding-inline-start: 20px !important;
}
.text-detail__list-item {
  font-size: 15.2px;
  font-weight: 400;
  line-height: 22.32px;
}
</style>
